
export async function getExchangeRates(): Promise<Record<string, number>> {
  const endpoints = [
    'https://open.er-api.com/v6/latest/USD',
    'https://api.exchangerate-api.com/v4/latest/USD',
    'https://api.frankfurter.app/latest?from=USD'
  ];

  for (const url of endpoints) {
    try {
      const response = await fetch(url);
      if (!response.ok) continue;
      const data = await response.json();
      
      // Normalize data based on endpoint
      if (url.includes('frankfurter')) {
        return { ...data.rates, USD: 1 };
      }
      return data.rates;
    } catch (error) {
      console.warn(`Failed to fetch from ${url}:`, error);
      continue;
    }
  }

  // Fallback to some common rates if all APIs fail
  return {
    USD: 1,
    EUR: 0.92,
    GBP: 0.79,
    JPY: 150.5,
    AUD: 1.52,
    CAD: 1.35,
    CHF: 0.88,
    CNY: 7.19,
    HKD: 7.82,
    NZD: 1.63,
    SEK: 10.38,
    KRW: 1332.5,
    SGD: 1.34,
    NOK: 10.55,
    MXN: 17.05,
    INR: 82.9,
    RUB: 92.5,
    ZAR: 19.1,
    TRY: 31.2,
    BRL: 4.97,
    TWD: 31.5,
    DKK: 6.87,
    PLN: 3.98,
    THB: 35.8,
    IDR: 15650,
    HUF: 360,
    CZK: 23.4,
    ILS: 3.65,
    CLP: 960,
    PHP: 56.1,
    AED: 3.67,
    COP: 3950,
    SAR: 3.75,
    MYR: 4.77,
    RON: 4.58,
    VND: 24650,
    PKR: 279,
    EGP: 30.9,
    NGN: 1500,
    AFN: 73,
    ALL: 95,
    AMD: 404,
    ANG: 1.79,
    AOA: 830,
    ARS: 840,
    AWG: 1.79,
    AZN: 1.7,
    BAM: 1.8,
    BBD: 2,
    BDT: 110,
    BGN: 1.8,
    BHD: 0.376,
    BIF: 2850,
    BMD: 1,
    BND: 1.34,
    BOB: 6.9,
    BSD: 1,
    BTN: 83,
    BWP: 13.7,
    BYN: 3.2,
    BZD: 2,
    CDF: 2750,
    CRC: 515,
    CUP: 24,
    CVE: 102,
    DJF: 178,
    DOP: 59,
    DZD: 134,
    ERN: 15,
    ETB: 56,
    FJD: 2.2,
    FKP: 0.79,
    GEL: 2.65,
    GHS: 12.5,
    GIP: 0.79,
    GMD: 67,
    GNF: 8600,
    GTQ: 7.8,
    GYD: 209,
    HNL: 24.7,
    HTG: 132,
    IQD: 1310,
    IRR: 42000,
    ISK: 137,
    JMD: 155,
    JOD: 0.71,
    KES: 145,
    KGS: 89,
    KHR: 4080,
    KMF: 453,
    KWD: 0.308,
    KYD: 0.83,
    KZT: 448,
    LAK: 20800,
    LBP: 15000,
    LKR: 312,
    LRD: 191,
    LSL: 19.1,
    LYD: 4.8,
    MAD: 10.1,
    MDL: 17.8,
    MGA: 4550,
    MKD: 56,
    MMK: 2100,
    MNT: 3450,
    MOP: 8.05,
    MRU: 39.5,
    MUR: 45.5,
    MVR: 15.4,
    MWK: 1680,
    MZN: 64,
    NAD: 19.1,
    NIO: 36.6,
    NPR: 133,
    OMR: 0.385,
    PAB: 1,
    PEN: 3.8,
    PGK: 3.7,
    PYG: 7300,
    QAR: 3.64,
    RSD: 108,
    RWF: 1280,
    SBD: 8.4,
    SCR: 13.5,
    SDG: 600,
    SHP: 0.79,
    SLL: 22000,
    SOS: 570,
    SRD: 35,
    SSP: 1000,
    STN: 22.5,
    SVC: 8.75,
    SYP: 13000,
    SZL: 19.1,
    TJS: 10.9,
    TMT: 3.5,
    TND: 3.1,
    TOP: 2.35,
    TTD: 6.8,
    TZS: 2550,
    UAH: 38.5,
    UGX: 3900,
    UYU: 39,
    UZS: 12450,
    VES: 36,
    VUV: 120,
    WST: 2.7,
    XAF: 600,
    XCD: 2.7,
    XOF: 600,
    XPF: 110,
    YER: 250,
    ZMW: 25,
    ZWL: 322
  };
}
